import React from 'react';
import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'

const Instructions = (props) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    var locations = [
        { type: "fixed-right", style: "btn-sm position-fixed top-50 end-0 translate-middle z-700" }
    ];

    var styling;
    if (props.type !== undefined) {
        var location = locations.find((x) => x.type === props.type);
        styling = location.style;
    }
    else {
        styling = props.className;
    }

    return (
        <>
            <Button variant="primary" onClick={handleShow} className={styling}><FontAwesomeIcon icon={faCircleInfo} /></Button>
            <Modal show={show}
                onHide={handleClose}
                keyboard={false}
                size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Application requirements and instructions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul>
                        <li>This Application must be filled out by the Applicant. You (the Applicant) are responsible to guarantee the information provided is accurate, complete, and truthful. Failure to complete any section will result in a delay in processing your application.</li>
                        <li>Do not cancel any health insurance coverage you currently have or decline COBRA benefits until you receive notice of acceptance from Health First Health Plans. Please retain a copy of this application for your records.</li>
                        <li>Any misrepresentation of information on the Application may result in cancellation of coverage.</li>
                        <li>All eligible family members must apply on one application.</li >
                        <li>A dependent from age 26 to age 30 must meet the eligibility requirements in accordance with Florida law.</li >
                        <li>To obtain coverage for a member&apos;s newborn or adopted child outside of the annual open enrollment period; a policyholder must complete and submit an Individual and Family Coverage Application or Change Form within sixty(60) days of the child&apos;s birth or placement in the home. Send the completed application, with the first month&apos;s premium payment, if applicable, to Health First Health Plans.</li >
                        <li>Please be advised that your quoted premium may be adjusted by Health First Health Plans as a result of enrollment fees, billing options, benefit / plan changes, available effective dates, age / birth date, tobacco use, or any other relevant factors.</li >
                        <li>Health First Health Plans complies with all federal regulations including guarantee issue provisions as outlined in the Health Insurance Portability and Accountability Act(HIPAA), and in the Affordable Care Act(ACA).</li >
                        <li>Please enter your benefit plan selection in Section 3 of the Application.</li >
                        <li>All information is confidential.</li >
                        <li>The Open Enrollment Period, or yearly period when people can enroll in a health insurance plan or make changes, runs from[Date of Open Enrollment].</li >
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Instructions
